export const DEFAULT_AUTH_RETURN_TO = "/dashboard";

const RETURN_TO_BASE = "https://app.invalid";

/**
 * Accept only same-origin application paths. Auth pages fall back to the
 * dashboard so a stale or malicious return_to value cannot create a loop.
 */
export function safeAuthReturnTo(value: string | null | undefined): string {
  if (!value || !value.startsWith("/") || value.startsWith("//")) {
    return DEFAULT_AUTH_RETURN_TO;
  }

  try {
    const target = new URL(value, RETURN_TO_BASE);
    if (target.origin !== RETURN_TO_BASE) {
      return DEFAULT_AUTH_RETURN_TO;
    }

    if (target.pathname === "/auth" || target.pathname.startsWith("/auth/")) {
      return DEFAULT_AUTH_RETURN_TO;
    }

    return `${target.pathname}${target.search}${target.hash}`;
  } catch {
    return DEFAULT_AUTH_RETURN_TO;
  }
}

export function loginPathFor(returnTo: string): string {
  return `/auth/login?return_to=${encodeURIComponent(safeAuthReturnTo(returnTo))}`;
}

/** The sign-in path that returns to `location` (FP-150): path, query and hash kept. */
export function signInPathFor(location: {
  pathname: string;
  search: string;
  hash: string;
}): string {
  return loginPathFor(`${location.pathname}${location.search}${location.hash}`);
}

/** AN-25: where Google/Apple sign-in and sign-up land after Clerk's callback. */
export function ssoCompleteUrl(returnTo: string): string {
  return `/auth/sso-complete?to=${encodeURIComponent(safeAuthReturnTo(returnTo))}`;
}

/** AN-25: Clerk's callback page, carrying `returnTo` through the redirect to the completion page. */
export function ssoCallbackUrl(returnTo: string): string {
  return `/auth/sso-callback?to=${encodeURIComponent(safeAuthReturnTo(returnTo))}`;
}
